import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-redirect-banner',
  templateUrl: './redirect-banner.component.html',
  styleUrls: ['./redirect-banner.component.scss'],
  imports: [],
})
export class RedirectBannerComponent {
  @Input() imageUrl = '';
  private readonly redirectUrl: string;

  constructor(
    private router: Router,
  ) {
    this.redirectUrl = '/marketplace/manage-packages/recommended';
  }
  onClick() {
    this.router.navigate([this.redirectUrl]);
  }
}
